var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12H10C8.34315 12 7 13.3431 7 15V24C7 25.6569 8.34315 27 10 27H22C23.6569 27 25 25.6569 25 24V15C25 13.3431 23.6569 12 22 12Z",
    stroke: "currentColor",
    strokeWidth: 1.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.56 9.05096C20.545 7.85297 20.0594 6.70896 19.2078 5.86614C18.3563 5.02332 17.2074 4.54939 16.0093 4.54676C14.8112 4.54414 13.6602 5.01302 12.805 5.8521C11.9498 6.69117 11.4591 7.83305 11.439 9.03096V11.2",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.652V21.352",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock-open.104534bb82d82713556cfd830852690a.svg";
export { ForwardRef as ReactComponent };